import saveComments from '../services/saveComments'

export default (formData) => {
	return new Promise(resolve => {
		saveComments(formData)
			.then(response => resolve({ success: true, data: response.data }))
	})
}
